<template>
  <div class="active-member">
    <div v-if="avatar" class="avatar">
        {{ name.charAt(0) }}
    </div>
    <div class="phrase-box">
        <div class="phrases" v-if="recentPhrases.length > 0">
            <p v-for="(phrase, index) in recentPhrases" v-bind:key="index">
                <span v-for="word in phrase" v-bind:key="word.id">{{word.text + ' '}}</span>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
import { db, Timestamp } from '../db';
import { groupWordsIntoPhrases, phraseAge } from '../wordUtils';

export default {
  name: 'Conversation',

  props: {
    avatar: Boolean,
    conversationId: String,
    memberId: String,
    name: String
  },

  data() {
      return {
          words: [],
          recentPhrases: []
      }
  },

  beforeMount() {
      //TODO smaller interval
      //TODO switch to event-based updates
      setInterval(this.renderWords.bind(this), 50);
  },

  methods: {
    renderWords: function() {
        const allPhrases = groupWordsIntoPhrases(this.words);
        //showing max 3 recent phrases, all must be less than 20s old
        const recentPhrases = allPhrases.filter(phrase => phraseAge(phrase) < 20).slice(-2);
        this.recentPhrases = recentPhrases;
    }
  },

  //TODO is there a better way to bind? smth more declarative
  //but we need to have conversationId and memberId so plain declarative binding won't work
  watch: {
    memberId: {
        immediate: true,
        handler(memberId) {
            const conversation = db.collection('conversations').doc(this.conversationId);
            const member = conversation.collection('members').doc(memberId);
            const earliest = Timestamp.now()
            earliest.seconds -= 30;
            this.$bind('words', member.collection('words').where('timestamp', '>', earliest).orderBy('timestamp'));
        }
    }
  }
}
</script>

<style scoped>
.active-member {
    display: flex;
    padding: 10px;
}
.avatar {
    display: inline-block;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    padding-top: 2px;
    font-size: 36px;
    border-radius: 30px;
    background-color: #6d547e;
    color: white;
    text-align: center;
    text-transform: capitalize;
}
.phrase-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    padding-left: 10px;
    font-size: 14px;
}

.phrases {
    padding: 0 10px 0 10px;
    border-radius: 8px;
    background-color: #ffffff;
    border: 1px solid #f0f0f0;
}

.phrase-box p {
    margin-bottom: 4px;
    margin-top: 2px;
}

.phrase-box p:first-child {
    color: #a0a0a0;
}
.phrase-box p:last-child {
    color: black;
}
</style>
